import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
  rows: [],
  filteredRows: [],
  refData: {
    packages: [],
    verticals: [],
    platforms: [],
  },
};

const setCDPData = (state, action) => {
  let cdpData = action.result.data;

  let updatedState = updateObject(state, {
    rows: cdpData,
    filteredRows: cdpData,
  });
  return updateObject(state, updatedState);
};

const storeRefData = (state, action) => {
  let updatedState = {
    refData: {
      packages: action.result.packagesData,
      verticals: action.result.verticalsData,
      platforms: action.result.platformsData,
    }
  }
  return updateObject(state, updatedState);
}

const filterRows = (state, action) => {
    let updatedState = updateObject(state, {
        filteredRows: action.updatedFilteredRows
    });
    return updateObject(state, updatedState);
};

function reducer(state = initialState, action) {
  let actionType;
  if(action) {
    actionType = action.type;
  } else actionType = '';
  switch (actionType) {
    case actionTypes.SET_CDP_DATA:
      return setCDPData(state, action);
    case actionTypes.STORE_REF_DATA:
      return storeRefData(state, action);
    case actionTypes.FILTER_ROWS:
      return filterRows(state, action);
    default:
      return state;
  }
}

export default reducer;
